<template>
  <el-col>
    <el-button type="primary" @click="openDialog">选择门店</el-button>

    <!-- 列表 -->
    <el-table
      ref="table"
      :data="activeShop.activeShopList"
      :header-cell-style="{
        background: '#e8eef8',
      }"
      border
      max-height="250px"
      class="active-shop-table"
    >
      <el-table-column align="center" prop="id" label="门店ID" />
      <el-table-column align="center" prop="name" label="门店名称" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <el-button
            v-if="!oldListId.includes(scope.row.id)"
            type="primary"
            link
            @click="del(scope.$index)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row
      v-if="activeShop.activeShopListAll.length > 0"
      class="page"
      style="width: 50%"
    >
      <el-pagination
        background
        :page-sizes="[5, 10, 15, 20, 25]"
        :current-page="activeShop.page"
        :page-size="activeShop.limit"
        small
        layout="total, sizes, prev, pager, next, jumper"
        :total="activeShop.activeShopListAll.length"
        @size-change="changeLimit($event)"
        @current-change="changePage($event)"
      />
    </el-row>
  </el-col>

  <!-- 门店列表 -->
  <v-dialog
    v-model:visible="isShowBox"
    width="60%"
    top="40px"
    title="门店列表"
    @really="handleShop"
  >
    <v-type-list title="" @query="query" @reset="reset">
      <template #search-condition-left>
        <el-col :span="6">
          <el-input
            v-model="tableParameter.value"
            class="w-50 m-2"
            placeholder="门店名称、ID"
            :prefix-icon="Search"
          />
        </el-col>
      </template>
      <template #table>
        <el-table
          ref="dialogTable"
          :data="dialogData.tableData"
          stripe
          style="width: 100%; height: 450px"
          :header-cell-style="{
            background: '#e8eef8',
          }"
          border
          @select-all="handleSelectAll"
          @select="handleSelect"
        >
          <template #empty>
            <el-empty v-loading="loading"></el-empty>
          </template>
          <el-table-column
            type="selection"
            :selectable="selectable"
            width="55"
          />
          <el-table-column align="center" property="id" label="门店编码">
            <template #default="scope">{{ scope.row.code }}</template>
          </el-table-column>
          <el-table-column align="center" property="name" label="门店名称" />
        </el-table>

        <el-row v-if="dialogData.total > 0" class="page">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :current-page="dialogData.page"
            :page-size="dialogData.limit"
            small
            layout="total, sizes, prev, pager, next, jumper"
            :total="dialogData.total"
            @size-change="changeLimit($event, 1)"
            @current-change="changePage($event, 1)"
          />
        </el-row>
      </template>
    </v-type-list>
  </v-dialog>
</template>
<script lang="ts" setup>
import { Search } from "@element-plus/icons-vue";
import { storeList } from "@/api/api";
import instance from "@/api/request";
import {
  ref,
  getCurrentInstance,
  reactive,
  nextTick,
  computed,
  watch,
  onMounted,
} from "vue";

export interface Props {
  list: any[];
  limit?: number;
  marking: string[];
  isDataHandle: boolean;
  merchantId: number;
  oldList: any[];
  url: string;
  param: any;
  method: string;
  searchNmae: string;
}

const props = withDefaults(defineProps<Props>(), {
  list: () => [],
  oldList: () => [], // 旧数据 禁用
  limit: -1, // 选择数量 -1 不限制
  marking: () => ["id", "name"],
  isDataHandle: false, // 数据转换
  merchantId: 0,
  // 默认不传url 展示全部门店
  url: "",
  param: () => {
    return {};
  },
  method: "get",
  searchNmae: "name",
});

const emits = defineEmits<{
  (e: "update:list", val: any[]): void;
}>();

const loading = ref(false);
const app = getCurrentInstance()?.proxy;
const dialogTable = ref();

const dialogData = reactive({
  tableData: [] as shopList[],
  page: 1,
  limit: 10,
  total: 0,
});

const tableParameter = reactive({
  value: "",
});

const initListData = () => {
  const list = props.list.map((f) => {
    return {
      id: f[props.marking[0]],
      name: f[props.marking[1]],
    };
  });

  activeShop.activeShopListAll = list;

  initActiveShopList();
};

const init = async () => {
  if (props.url) {
    getShopOther();
  } else {
    getShopAll();
  }
};

// 获取全部门店
const getShopAll = async () => {
  const { page, limit } = dialogData;
  const dt = {
    merchantId: props.merchantId || app?.$app.merchantId,
    status: 1,
    value: tableParameter.value,
    page: page,
    limit: limit,
  };
  const res = await storeList(dt);
  if (res.code == 200) {
    const { list, count } = res.data;
    dialogData.tableData = list;
    dialogData.total = count;
    dialogCheckbox();
  } else {
    app?.$message.error(res.message);
  }
};

// 获取其他门店
const getShopOther = () => {
  const { page, limit } = dialogData;

  const dt = {
    page: page,
    limit: limit,
    ...props.param,
    [props.searchNmae]: tableParameter.value,
  };
  instance[props.method](props.url, dt).then((res: any) => {
    if (res.code === 200) {
      const { list, count } = res.data;
      dialogData.tableData = list;
      dialogData.total = count;
      dialogCheckbox();
    } else {
      app?.$message.error(res.message);
    }
  });
};

const oldListId = computed(() => {
  return props.oldList.map((f) => f[props.marking[0]]);
});

const selectable = (row: shopList) => {
  return !oldListId.value.includes(row.id);
};

// 查询
const query = () => {
  init();
};

// 重置
const reset = () => {
  dialogData.page = 1;
  dialogData.limit = 10;
  tableParameter.value = "";
  init();
};

const isShowBox = ref(false);
const openDialog = () => {
  reset();
  isShowBox.value = true;
};

const activeShop = reactive({
  page: 1,
  limit: 5,
  activeShopList: [] as shopList[],
  activeShopListAll: [] as shopList[],
});

const ShopIdListAll = computed(() => {
  return activeShop.activeShopListAll.map((f) => f.id);
});

const initActiveShopList = () => {
  // 起始位置
  const start = (activeShop.page - 1) * activeShop.limit;
  // 结束位置
  const end = activeShop.page * activeShop.limit;

  // 返回切割数组后的数据
  activeShop.activeShopList = activeShop.activeShopListAll.slice(start, end);
  return;
};

// 用户手动勾选
const handleSelect = (e: shopList[], row: shopList) => {
  // 判断当前用户是勾选还是取消
  const checkItOrNot = e.find((f) => f.id == row.id);

  if (checkItOrNot) {
    // 超过最大数量取消勾选
    if (
      props.limit != -1 &&
      activeShop.activeShopListAll.length >= props.limit
    ) {
      dialogTable.value.toggleRowSelection(row, false);
      return app?.$message.error(`最多只能选择${props.limit}个门店`);
    }

    activeShop.activeShopListAll.push(row);
  } else {
    activeShop.activeShopListAll = activeShop.activeShopListAll.filter(
      (f) => f.id != row.id
    );
  }
};

// 全选
const handleSelectAll = (e: shopList[]) => {
  if (e.length) {
    // 去重
    const res = new Map();
    const allList = [...activeShop.activeShopListAll, ...e].filter(
      (f) => !res.has(f.id) && res.set(f.id, 1)
    );

    // 超过最大数量取消勾选
    if (props.limit != -1 && allList.length > props.limit) {
      e.forEach((f, i) => {
        if (!ShopIdListAll.value.includes(f.id)) {
          // 注意 ： 一定要异步
          setTimeout(() => {
            dialogTable.value.toggleRowSelection(f, false);
          });
        }
      });
      return app?.$message.error(`最多只能选择${props.limit}个门店`);
    }

    activeShop.activeShopListAll = allList;
  } else {
    const idList = dialogData.tableData.map((f) => f.id);
    activeShop.activeShopListAll = activeShop.activeShopListAll.filter(
      (f) => !idList.includes(f.id)
    );
  }
};

const handleShop = () => {
  isShowBox.value = false;
  initActiveShopList();
};

// 删除
const del = (index: number) => {
  activeShop.activeShopListAll = activeShop.activeShopListAll.filter(
    (f) => f.id != activeShop.activeShopList[index].id
  );
  activeShop.activeShopList.splice(index, 1);
  initActiveShopList();
};

// 组件回显勾选
const dialogCheckbox = () => {
  if (!ShopIdListAll.value.length) return;
  nextTick(() => {
    dialogData.tableData.forEach((f) => {
      if (ShopIdListAll.value.includes(f.id)) {
        dialogTable.value.toggleRowSelection(f, true);
      }
    });
  });
};

//切换显示数量
const changeLimit = (myLimit: number, type?: number) => {
  if (type) {
    dialogData.limit = myLimit;
    init();
  } else {
    activeShop.limit = myLimit;
    initActiveShopList();
  }
  return false;
};

//切换分页
const changePage = (myPage: number, type?: number) => {
  if (type) {
    dialogData.page = myPage;
    init();
  } else {
    activeShop.page = myPage;
    initActiveShopList();
  }
  return false;
};

watch(
  () => activeShop.activeShopListAll,
  (newVal) => {
    emits("update:list", newVal);
  },
  { deep: true, immediate: true }
);

watch(
  () => props.list,
  (newVal) => {
    if (newVal && newVal.length) {
      if (
        newVal[0][props.marking[0]] &&
        newVal[0][props.marking[1]] &&
        props.isDataHandle
      ) {
        initListData();
      }
    }
  },
  { deep: true, immediate: true }
);

defineExpose({
  activeShop,
});
</script>
<style lang="scss" scoped>
.page {
  margin-top: 20px;
  justify-content: flex-end;
}
.active-shop-table {
  width: 50%;
  margin-top: 10px;
}
</style>
